export const environment = {
  production: true,
  configUrl: 'config/config.json',
  recaptchaSiteKey: '6Lc5k-QZAAAAAJIxKPeJZu5zyDgMNp9c7d7vGLGO',
  recaptchaIdName: 'recaptcha-private-key'
};
